import { useContext } from "react";
import Screen from "../../layout/screen";
import { AppContext } from "../../context/AppContext";
import FullPageLoader from "../../components/full-page-loader";
import { TransferContext } from "../../context/TransferContext";

const TransferScreen = () => {
  const { isAppLoading } = useContext(AppContext);
  const { showError } = useContext(TransferContext);
  if (showError !== undefined) {
    throw Error(showError);
  }

  if (isAppLoading) return <FullPageLoader />;
  return <Screen />;
};

export default TransferScreen;
